export default "__VITE_ASSET__C_AwN7u2__"